import { createSlice, createSelector } from '@reduxjs/toolkit';
import { getTranslations } from 'api/Languages';
import { fetchWithLanguage } from 'store/helpers';

export const fetchTranslations = fetchWithLanguage('fetchTranslations', getTranslations);

const transltionsSlice = createSlice({
    name: 'transltionsSlice',
    initialState: {
        data: {},
    },
    reducers: {},
    extraReducers: builder => {
        builder.addCase(fetchTranslations.fulfilled, (state, action) => {
            state.data = action.payload;
        });
    },
});

export const selectTranslations = createSelector([state => state.translationsState.data], data => data.data || {});

export default transltionsSlice.reducer;
